import { render, staticRenderFns } from "./LocalParticipationEvents.vue?vue&type=template&id=af0e60a8&scoped=true"
import script from "./LocalParticipationEvents.vue?vue&type=script&lang=js"
export * from "./LocalParticipationEvents.vue?vue&type=script&lang=js"
import style0 from "./LocalParticipationEvents.vue?vue&type=style&index=0&id=af0e60a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0e60a8",
  null
  
)

export default component.exports